import { useEffect, useState } from "react";
import { Download, Mail } from "lucide-react";

const FILTERS = [["", "All"], ["texture", "Texture"], ["reactor", "Reactor"], ["skin", "Skin"], ["denoise", "Denoise"], ["genalpha", "Gen Alpha"], ["recast", "Recast"], ["rolloff", "Film Compression"]];
const day = (iso) => (iso ? new Date(iso).toLocaleDateString() : "");

export function AdminLeads({ admin }) {
  const [product, setProduct] = useState("");
  const [data, setData] = useState(null);
  useEffect(() => {
    admin.get("/leads", { params: product ? { product } : {} }).then((r) => setData(r.data)).catch(() => setData({ leads: [], total: 0, emails: 0 }));
  }, [admin, product]);
  const exportCsv = async () => {
    const r = await admin.get("/leads.csv", { params: product ? { product } : {}, responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data); a.download = "kolorklinic-download-emails.csv"; a.click();
    URL.revokeObjectURL(a.href);
  };
  return (
    <section className="space-y-3" data-testid="admin-leads">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="font-display uppercase text-2xl flex items-center gap-2"><Mail size={18} className="text-[#e69d27]" /> Download emails</h2>
        {data && <span className="font-mono text-xs text-[#9ba3b4]" data-testid="admin-leads-count">{data.emails} people · {data.total} downloads</span>}
        <select className="ml-auto bg-black border border-[#2a2f3d] px-3 py-1.5 text-sm" value={product} onChange={(e) => setProduct(e.target.value)} data-testid="admin-leads-filter">
          {FILTERS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <button onClick={exportCsv} className="btn-amber px-3 py-1.5 text-xs flex items-center gap-1.5" data-testid="admin-leads-export-btn"><Download size={12} /> Export CSV</button>
      </div>
      <div className="max-h-[420px] overflow-auto border border-[#2a2f3d]">
        <table className="w-full text-sm" data-testid="admin-leads-table">
          <thead className="text-left font-mono text-[11px] uppercase tracking-widest text-[#5c6479] sticky top-0 bg-[#0b0c0e]">
            <tr><th className="p-2">Email</th><th>Plugin</th><th>First download</th><th>Last download</th></tr>
          </thead>
          <tbody>
            {(data?.leads || []).map((l) => (
              <tr key={`${l.email}-${l.product}`} className="border-t border-[#1c1f27]" data-testid="admin-lead-row">
                <td className="p-2 font-mono">{l.email}</td><td>{l.name}</td><td>{day(l.created_at)}</td><td>{day(l.updated_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data && data.leads.length === 0 && <p className="p-3 text-sm text-[#5c6479]" data-testid="admin-leads-empty">No download emails yet.</p>}
      </div>
    </section>
  );
}
